var map = {
	"./dev/abstract-handler": 4990,
	"./dev/abstract-handler.tsx": 4990,
	"./dev/handler": 7707,
	"./dev/handler.tsx": 7707,
	"./dev/map-handler": 3479,
	"./dev/map-handler.tsx": 3479,
	"./prod/abstract-handler": 6192,
	"./prod/abstract-handler.tsx": 6192,
	"./prod/handler": 5417,
	"./prod/handler.tsx": 5417,
	"./prod/map-handler": 4500,
	"./prod/map-handler.tsx": 4500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8427;